import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .lastSync{
        margin-top: 10px;
        width: 100%;
        display: flex;
        justify-content: flex-end;

        span{
            margin-right: 15px;
            background: var(--colorBackgroundCardsDashboard);
            padding: 0.3rem;
            margin-right: 0.5rem;
            color: gray;
            font-size: 0.7rem;
            font-weight: 500;
        }
    }

    strong{
        width: 90%;
        color: gray;
        margin-bottom: 10px;
        
    }
`;